module.exports = __webpack_public_path__ + "img/tm.2c41cd01.svg";